<template lang="pug">
	.grid-banner__grid(v-if="items && items.length")

		.grid-banner__row.grid-banner__row--top(v-if="topRow.length")
			.grid-banner__col.flc(
				v-for="(item, index) in topRow"
				:key="'top-' + index"
				:class="index === 0 ? 'grid-banner__col--wide' : 'grid-banner__col--narrow'"
			)
				.grid-banner__item(:class="`grid-banner__item--${item.color}`")
					img.grid-banner__item-image(v-if="item.image" :src="item.image")
					.grid-banner__item-title(v-if="item.title") {{ item.title }}
					.grid-banner__item-text(v-if="item.text" v-html="item.text")
					.grid-banner__item-icon-wrap(:class="{'grid-banner__item-icon-wrap--transparent': item.image}")
						v-svg-icon.grid-banner__item-icon(:icon="item.icon || 'flower'")

		.grid-banner__row.grid-banner__row--bottom(v-if="bottomRow.length")
			.grid-banner__col.flc(
				v-for="(item, index) in bottomRow"
				:key="'bottom-' + index"
				:class="index === 0 ? 'grid-banner__col--narrow' : 'grid-banner__col--wide'"
			)
				.grid-banner__item(:class="`grid-banner__item--${item.color}`")
					img.grid-banner__item-image(v-if="item.image" :src="item.image")
					.grid-banner__item-title(v-if="item.title") {{ item.title }}
					.grid-banner__item-text(v-if="item.text" v-html="item.text")
					.grid-banner__item-icon-wrap(:class="{'grid-banner__item-icon-wrap--transparent': item.image}")
						v-svg-icon.grid-banner__item-icon(:icon="item.icon || 'flower'")
</template>

<script>
export default {
	props: {
		items: {
			type: Array,
			default: () => []
		}
	},

	computed: {
		topRow() {
			return this.items.slice(0, 2);
		},
		bottomRow() {
			return this.items.slice(2, 4);
		}
	},

	mounted() {
		// console.log(this.items);
	}
}
</script>